import Delete from "../Icon/Delete";
import "./CustomVideo.scss";
import React from "react";

function CustomVideo(props: any) {
  // 動画が存在するかどうかの判定（video_url または video_file_name があれば存在）
  const hasVideo = props.url || props.video_file_name;
  
  return (
    <div className="custom_video_right">
      {hasVideo ? (
        <>
          {props.preparing ? (
            <p>動画準備中です。</p>
          ) : (
            <div className="on_same_row" style={{ alignItems: "end" }}>
              {props.url ? (
                <video
                  controls
                  src={props.url}
                  className="custom_video"
                />
              ) : (
                <p>動画ファイル: {props.video_file_name}</p>
              )}
              <Delete func={props.deleteVideo} />
            </div>
          )}
          <p>動画を変更する場合はファイルを選択</p>
        </>
      ) : (
        <p>動画がありません。</p>
      )}
      <input
        className="custom_video_input"
        type="file"
        accept="video/*"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (e.currentTarget.files !== null) {
            const file = e.currentTarget.files[0];
            props.setVideo(file);
          }
        }}
      />
    </div>
  );
};

export default CustomVideo;
